import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Session } from '../../business-objects/session/session.model';
import { Subject } from 'rxjs/Subject';
import { ConnectableObservable } from 'rxjs/observable/ConnectableObservable';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';

@Injectable()
export class GuardService {

    protected autoGuardInitialised: boolean = false;

    protected page: string;
    protected currentPage: string;
    protected _page$ = new Subject<string>();
    protected page$: ConnectableObservable<string>;

    protected pages = {
        LOGIN: "LoginPage",
        ACCOUNTS: "AccountsPage"
    };

    protected isOnline: boolean;
    protected isAuthenticated: boolean;

    constructor(protected appFacade: VasAppFacade) {
        this.page = this.pages.LOGIN;
        this.page$ = this._page$.publish();
    }

    init(): void {

        if (this.autoGuardInitialised) {
            throw new Error("guard service already initialised");
        }

        console.log("guarding");

        this.autoGuardInitialised = true;
        this.page$.connect();
        this.setPage(this.currentPage);

        this.appFacade.session.getSession().subscribe(session => {
            this.handleGuard(session);
        });
    }

    setCurrentPage(page: string): void {
        page = !page.match(/Page$/) ? "LoginPage" : page;
        // console.log("setCurrentPage", page);
        this.currentPage = page;
    }

    getPage(): Observable<string> {
        return this.page$
            .do(page => console.log("page$", page))
            .filter(page => !!page);
    }

    setPage(page: string, force = false): void {

        if (!force && page === this.page) return;

        console.log("setPage", page);
        this.page = page;
        this._page$.next(page);
    }

    protected handleGuard(session: Session): void {

        const isSignedIn = session.isSignedIn();
        const networkStatus = session.getNetworkStatus();

        // console.log("handle guard:");
        // console.log("> is signed in", isSignedIn);
        // console.log("> online", networkStatus.isOnline());
        // console.log("> authenticated", networkStatus.isAuthenticated());

        const online = networkStatus.isOnline();
        const authenticated = networkStatus.isAuthenticated();

        switch (true) {
            // wasn't signed in, not online, not authenticated = warn 'first time'
            case !isSignedIn && !online && !authenticated: {
                // this.appFacade.toast.toastWarning("warnings.first-time-sign-in-must-be-online");
                this.setPage(this.pages.LOGIN);
                break;
            }
            // was signed in, online, not authenticated = login
            case isSignedIn && online && !authenticated: {
                // @todo try to reauthorise using refresh_token
                this.setPage(this.pages.LOGIN);
                break;
            }
            // was signed in, not online, not authenticated = accounts
            case isSignedIn && !online && !authenticated:
            // was signed in, online, authenticated = accounts
            case isSignedIn && online && authenticated: {
                this.setPage(this.currentPage);
                break;
            }
            // wasn't signed in, offline, authenticated = login (not possible)
            // wasn't signed in, online, not authenticated = login
            // wasn't signed in, online, authenticated = login
            // was signed in, not online, authenticated = login (not possible)
            default: {
                this.setPage(this.pages.LOGIN);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/services/guard/guard.service.ts